import { HorizontalBarChart } from '@components/ScreenerResults/ScreenerChart/components/HorizontalBarChart';
import { PieChart } from '@components/ScreenerResults/ScreenerChart/components/PieChart';
import { TextCarousel } from '@components/ScreenerResults/ScreenerChart/components/TextCarousel';
import { VerticalBarChart } from '@components/ScreenerResults/ScreenerChart/components/VerticalBarChart';
import { ChartableType, ChartComponent } from '@components/ScreenerResults/ScreenerChart/types';
import { getTailwindColor } from '@components/utils';

export const colors = [
  getTailwindColor('Gray', 400),
  getTailwindColor('Red', 400),
  getTailwindColor('Orange', 400),
  getTailwindColor('Yellow', 400),
  getTailwindColor('Green', 400),
  getTailwindColor('Teal', 400),
  getTailwindColor('Blue', 400),
  getTailwindColor('Indigo', 400),
  getTailwindColor('Purple', 400),
  getTailwindColor('Pink', 400)
];

export const CHARTS_BY_FIELD_TYPE: Record<ChartableType, ChartComponent | null> = {
  info: null,
  start_loom: null,
  stop_loom: null,
  task: null,
  multiple_choice: HorizontalBarChart,
  single_choice: PieChart,
  text: TextCarousel,
  short_text: TextCarousel,
  long_text: TextCarousel,
  free_text: TextCarousel,
  email: TextCarousel,
  website: TextCarousel,
  url: TextCarousel,
  number: VerticalBarChart,
  number_range: PieChart,
  boolean: PieChart,
  yes_no: PieChart,
  date: TextCarousel,
  datetime: TextCarousel,
  location: TextCarousel,
  prototype_test: HorizontalBarChart,
  card_sort: null,
  tree_test: null,
  matrix: HorizontalBarChart
};
